var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 170,
    viewBox: "0 0 1440 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_32157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 98.4688C126.922 113.224 0 98.4688 0 98.4688L0.000450134 169.996L1440 170V98.4688C1440 98.4688 1313.08 113.224 1234 98.4688C1200.61 92.2387 1181.83 87.7825 1150 75.9426C1094.26 55.2088 1077.41 3.00458 1018 0.0952704C970.234 -2.24378 902 39.264 902 39.264H538C538 39.264 469.766 -2.24378 422 0.0952704C362.589 3.00458 345.737 55.2088 290 75.9426C258.171 87.7825 239.389 92.2387 206 98.4688Z",
    fill: "#E97219"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_32157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLayer);
export default __webpack_public_path__ + "static/media/footer-layer.ec9a10af556071f6018b04cbc3464d32.svg";
export { ForwardRef as ReactComponent };